/**
 * Store admin — full-tab live preview of one appearance template (spec 50 R8).
 *
 * Opened in a new tab from the appearance library's template gallery.
 */
import { createFileRoute } from "@tanstack/react-router";
import { TemplatePreviewPage } from "../../../../../../../features/store/storefront/template-preview-page.tsx";

export const Route = createFileRoute(
  "/(workspace)/store/admin/storefront/templates/$templateKey/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { templateKey } = Route.useParams();
  return <TemplatePreviewPage templateKey={templateKey} />;
}
